export abstract class Bytes {
  static kilobytes(bytes: number) {
    return bytes / 1024;
  }
  static megabytes(bytes: number) {
    return Bytes.kilobytes(bytes) / 1024;
  }
  static gigabytes(bytes: number) {
    return Bytes.megabytes(bytes) / 1024;
  }
  static terabytes(bytes: number) {
    return Bytes.gigabytes(bytes) / 1024;
  }
}

